(function () {
  const flags = {
    EGP: '🇪🇬',
    USD: '🇺🇸',
    EUR: '🇪🇺',
    GBP: '🇬🇧',
    CAD: '🇨🇦',
    AED: '🇦🇪',
    SAR: '🇸🇦',
    KWD: '🇰🇼',
  };

  function getActiveCurrency() {
    return (
      localStorage.getItem('bacurr_user_cur') ||
      (window.baCurr && window.baCurr.config && window.baCurr.config.user_curr) ||
      'EGP'
    );
  }

  function updateCurrencyDisplay(curr) {
    const flag = flags[curr] || '🌍';
    const drawerFlag = document.getElementById('grabora-drawer-curr-flag');
    const drawerCode = document.getElementById('grabora-drawer-curr-code');
    const footerFlag = document.getElementById('grabora-footer-curr-flag');
    const footerCode = document.getElementById('grabora-footer-curr-code');

    if (drawerFlag) drawerFlag.textContent = flag;
    if (drawerCode) drawerCode.textContent = curr;
    if (footerFlag) footerFlag.textContent = flag;
    if (footerCode) footerCode.textContent = curr;

    document.querySelectorAll('.grabora-curr-opt').forEach((opt) => {
      if (opt.dataset.curr === curr) {
        opt.classList.add('is-active');
      } else {
        opt.classList.remove('is-active');
      }
    });
  }

  function switchCurrency(curr) {
    localStorage.setItem('bacurr_user_cur', curr);
    updateCurrencyDisplay(curr);

    // 1. If Nova/Booster currency selector exists, trigger it
    const novaSelect = document.querySelector('select#baCurrSelector, select.bacurr');
    if (novaSelect) {
      novaSelect.value = curr;
      novaSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    const novaChoice = document.querySelector(`.bacurr-dropdown-choices li#${curr}`);
    if (novaChoice) {
      novaChoice.click();
    }

    // 2. Submit to /cart/update.js
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ currency: curr }),
    })
      .then(() => {
        if (window.baCurr && typeof window.baCurr.rePeat === 'function') {
          window.baCurr.rePeat();
        } else {
          window.location.reload();
        }
      })
      .catch(() => {
        window.location.reload();
      });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const initialCurr = getActiveCurrency();
    updateCurrencyDisplay(initialCurr);

    document.querySelectorAll('.grabora-curr-opt').forEach((opt) => {
      opt.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const selected = this.dataset.curr;
        if (selected) {
          switchCurrency(selected);
          const details = this.closest('details');
          if (details) details.removeAttribute('open');
        }
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.grabora-footer-currency-details[open]').forEach((d) => {
        if (!d.contains(e.target)) d.removeAttribute('open');
      });
    });
  });
})();
